/**
 * Returns boolean whether any races have tickets.
 */
export default (races = []) => races.filter(r => !!r.tickets).length > 0;



// WEBPACK FOOTER //
// ./app/src/components/EventHeader/BookNow/helpers/racesHaveTickets.js